import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withDashboard from "../../HOC/withDashboard";
import Pagination from "../../components/Pagination";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getCustomReferralCode,
  deleteCustomReferralCode,
  setAdminReferral,
} from "../../redux/actions/customReferralAction";
import { setUser, setUserDetailProfile } from "../../redux/actions/userAction";
import {
  ButtonBase,
  Button,
  InputAdornment,
  TextField,
  Card,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import "../Users/index.css"; // Reuse Users styling for consistency
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
import { fetchCustomeReferralCode } from "../../services/CustomReferralCodeService";

const CustomReferralCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState(false);
  const [customReferralCode, setCustomReferralCode] = React.useState([]);
  const User = useSelector(({ User }) => User);
  const {
    filteredReferrals,
    paginatedReferrals,
    currentReferralPage,
    totalReferralPages,
    referralPerPage,
    referralSearch,
    testConfig,
    prodConfig,
    enviroment,
  } = User;
  const [totalRecord, setTotalRecord] = useState(0);
  const [dataRecord, setDataRecord] = React.useState([]);
  const [dataRecordFilter, setDataRecordFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    getDataRecord();
  }, [dataRecordFilter]);

  const onChangeFilter = (name, value) => {
    setDataRecordFilter({ ...dataRecordFilter, [name]: value });
  };

  const getDataRecord = () => {
    setIsLoading(true);
    dispatch(fetchCustomeReferralCode(dataRecordFilter))
      .then((res) => {
        setTotalRecord(res?.data?.data?.total);
        setDataRecord(res?.data?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching gift card categories:", message);
        setIsLoading(false);
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCustomReferralCode({ id }));
        getDataRecord();
      }
    });
  };

  const onViewReferral = (referral) => {
    dispatch(
      setAdminReferral({
        name: "selectedReferral",
        value: referral,
      })
    );
    navigate("/viewReferral");
  };

  const setTotalPages = (totalpages) => {
    dispatch(
      setAdminReferral({
        name: "totalReferralPages",
        value: totalpages,
      })
    );
  };
  const setCurrentPage = (currentPage) => {
    dispatch(
      setAdminReferral({
        name: "currentReferralPage",
        value: currentPage,
      })
    );
  };
  const setPaginatedItems = (paginatedItems) => {
    dispatch(
      setAdminReferral({
        name: "paginatedReferrals",
        value: paginatedItems,
      })
    );
  };
  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value;
    dispatch(
      setAdminReferral({
        name: "referralPerPage",
        value,
      })
    );
  };
  console.log({ customReferralCode });

  const onReferralViewUser = (user) => {
    dispatch(
      setUser({
        name: "selectedUser",
        value: user,
      })
    );
    dispatch(setUserDetailProfile(user));
    navigate("/viewAdminReferral");
  };

  return (
    <Fragment>
      <div className="table-layout-container">
        <Card className="gift-cards-category-card">
          <div className="table-title">
            <span>List of Referrals</span>
            <div>
              <button
                className="user-add-btn"
                style={{
                  padding: "8px 16px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={() => navigate("/CustomReferralCode/Form")}
              >
                + Add Referral Code
              </button>
            </div>
          </div>
          <div className="gift-cards-table-container">
            {isLoading ? (
              <div className="flex justify-center items-center p-4">
                <CircularProgress />
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataRecord &&
                    dataRecord.length > 0 &&
                    dataRecord.map((item) => (
                      <tr key={item?._id}>
                        <td>{item._id}</td>
                        <td>{item.name}</td>
                        <td>{item.code}</td>
                        <td>
                          {item.status && item.status == "1"
                            ? "Active"
                            : "Inactive"}
                        </td>
                        <td>
                          <div className="action-row">
                            <IconButton
                              className="mr-2"
                              aria-label="Referral View"
                              onClick={() => onReferralViewUser(item)}
                            >
                              <PeopleSharpIcon />
                            </IconButton>
                            <Button
                              className="action-btn edit"
                              variant="contained"
                              onClick={() =>
                                navigate(`/CustomReferralCode/Form/${item._id}`)
                              }
                            >
                              <PreviewIcon />
                              <span> Edit</span>
                            </Button>
                            <Button
                              className="ml-1 bg-red-500 action-btn "
                              variant="contained"
                              color="error"
                              onClick={() => handleDelete(item._id)}
                            >
                              <DeleteIcon />
                              <span>Delete</span>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="gift-cards-pagination-container">
            <Pagination
              items={totalRecord}
              initialPage={dataRecordFilter?.page}
              onChangePage={onChangeFilter}
              per_page={dataRecordFilter?.limit}
            />
          </div>
        </Card>
      </div>
    </Fragment>
  );
};
export default withDashboard(CustomReferralCode);
